import {useQuery} from '@tanstack/react-query'
import {queryKeys} from '../../constants/queryKey'
import {getMajorCustomer} from '../../api/majorCustomer'

function useGetMajorCustomersQuery() {
  return useQuery<any>([queryKeys.majorCustomer], () => getMajorCustomer({limit: 8}), {})
}

export default useGetMajorCustomersQuery
